/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Modal, Card, Table, Form, Input, Spin, Space, Row, Col, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import JobOrderService from "../../../../service/ERP/JobOrder.service";
import TagJoStatus from "../../../badge-and-tag/ERP/tags-jo-status/TagJoStatus";
import dayjs from "dayjs";

const joService = JobOrderService();

export default function ModalJobOrder({ show, close, selected }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [dataWrap, setDataWrap] = useState([]);

  const handleClose = () => {
    setTimeout(() => close(false), 140);
  };

  const handleChoose = (record) => {
    selected(record);
    close(false);
  };

  const handleSearch = (value) => {
    if (!value) {
      setDataWrap(allData);
      return;
    }
    const kw = value.toLowerCase();
    const s = (v) => (v == null ? "" : String(v)).toLowerCase();
    setDataWrap(
      allData.filter(
        (d) =>
          s(d.jocode).includes(kw) ||
          s(d.cusname).includes(kw) ||
          s(d.brand).includes(kw) ||
          s(d.pi_no).includes(kw)
      )
    );
  };

  const loadData = () => {
    setLoading(true);
    joService
      /* ใบที่ยกเลิกแล้วไม่ให้เลือกไปสร้างเอกสารอื่น */
      .search({ exclude_cancel: 1 })
      .then((res) => {
        const data = res.data?.data || [];
        setAllData(data);
        setDataWrap(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (show && allData.length === 0) loadData();
  }, [show]);

  const columns = [
    {
      title: "JO Code",
      key: "jocode",
      dataIndex: "jocode",
      width: 100,
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>{v}</Typography.Link>
      ),
    },
    {
      title: "ลูกค้า",
      key: "cusname",
      dataIndex: "cusname",
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>{v}</Typography.Link>
      ),
    },
    {
      title: "Brand",
      key: "brand",
      dataIndex: "brand",
      width: 140,
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>{v}</Typography.Link>
      ),
    },
    {
      title: "PI No.",
      key: "pi_no",
      dataIndex: "pi_no",
      width: 130,
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>{v}</Typography.Link>
      ),
    },
    {
      title: "วันที่",
      key: "jodate",
      dataIndex: "jodate",
      width: 110,
      align: "center",
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>
          {v ? dayjs(v).format("DD/MM/YYYY") : "-"}
        </Typography.Link>
      ),
    },
    {
      title: "สถานะ",
      key: "doc_status",
      dataIndex: "doc_status",
      width: 120,
      align: "center",
      render: (v, record) => (
        <Typography.Link onClick={() => handleChoose(record)}>
          <TagJoStatus result={v} />
        </Typography.Link>
      ),
    },
  ];

  return (
    <Modal
      open={show}
      title="เลือก Job Order"
      afterClose={handleClose}
      onCancel={() => close(false)}
      footer={null}
      maskClosable={false}
      style={{ top: 20, maxWidth: "96vw" }}
      width={1100}
    >
      <Spin spinning={loading}>
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={[8, 0]}>
                <Col span={24}>
                  <Form.Item label="ค้นหา">
                    <Input
                      suffix={<SearchOutlined />}
                      placeholder="JO Code / ลูกค้า / Brand / PI No."
                      onChange={(e) => handleSearch(e.target.value)}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
          <Card style={{ minHeight: "55vh" }}>
            <Table
              bordered
              size="small"
              rowKey="jocode"
              dataSource={dataWrap}
              columns={columns}
              scroll={{ x: "max-content", y: 400 }}
              pagination={{
                total: dataWrap.length,
                showTotal: (_, range) => `${range[0]}-${range[1]} of ${allData.length} items`,
                defaultPageSize: 25,
                pageSizeOptions: [25, 50, 100],
              }}
            />
          </Card>
        </Space>
      </Spin>
    </Modal>
  );
}
